import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { Mode } from '../../constants/enums';
import { storeResources } from '../resources';
import { getStorageThemeMode, setStorageThemeMode } from '../../constants/storage';

interface InitialState {
  mode: Mode;
}

const initialState: InitialState = {
  mode: getStorageThemeMode(),
};

const themeModeSlice = createSlice({
  name: storeResources.THEME_MODE,
  initialState,
  reducers: {
    setThemeMode: (state: InitialState, action: { payload: Mode }) => {
      state.mode = action.payload;
      setStorageThemeMode(action.payload);
    },
  },
});

export default themeModeSlice.reducer;

export const ThemeModeSelector = (state: RootState): Mode => state[storeResources.THEME_MODE].mode;

export const { setThemeMode } = themeModeSlice.actions;
